import React, {useState, useEffect} from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import MenuItem from "@material-ui/core/MenuItem";

import AccountBalance from "@material-ui/icons/AccountBalance";
import FilterList from "@material-ui/icons/FilterList";
import SwapHoriz from "@material-ui/icons/SwapHoriz";
import Motorcycle from "@material-ui/icons/Motorcycle";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import SettingsIcon from '@material-ui/icons/Settings';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import { getTimestamp } from './components/timeStamp.js'
import { userAtom } from "./atom.js"
import { useRecoilState } from 'recoil'

import UntiedAppBar from "./appbar";
import { isMobile } from 'react-device-detect';
import { Link, Redirect } from "react-router-dom";
import { Mixpanel } from "./mixpanel";
import "./index.css";

let view = window.location.pathname.replace("/","");

export default function MiniDrawer(props) {
  const classes = useStyles();
  const drwr = isMobile ? true : localStorage.getItem("DRAWEROpen") === "true";
  const [closed, setClosed] = React.useState(drwr);
  const rotate = closed ? "rotate(180deg)" : "rotate(360deg)";
  const [loggedInAs, setLoggedInAs] = useState(localStorage.getItem("logged_in_as"));
  const plan = localStorage.has_sub;
  const [viewedPage, setViewedPage] = useState("")

  const userEmail = localStorage.getItem("username");
  const advisor = localStorage.getItem("agent") 
  const [user_atom, ] = useRecoilState(userAtom);

  useEffect(()=>{
    let pathname = window.location.pathname.substring(1)
    if(pathname !== viewedPage){
      if(pathname == 'taxreturn/form'){
        pathname = "taxReturns"
      }
      if(pathname == 'tutorials/menu'){
        pathname = "tutorials"
      }
      if(pathname == 'taxForms/menu'){
        pathname = "taxForms"
      }
      // debugger
      view = pathname
      setViewedPage(pathname)
    }

    if(props.location){
    let sub = props.location.pathname.substring(1)
      if (view !== sub){
        view = sub
        setViewedPage(view)
      }
    }
    else if(view == "logout/logout"){
      view = "home"
      setViewedPage('home')
    }

  }, [])


  function handleDrawerOpen() {
    setClosed(false);
    localStorage.setItem("DRAWEROpen", false);
    Mixpanel.track("open drawer");
  }

  function handleDrawerClose() {
    setClosed(true);
    localStorage.setItem("DRAWEROpen", true);
    Mixpanel.track("close drawer");
  }

  function isMTDUser() {
    return localStorage.getItem("mtd") !== "N"
  }

  function setActiveView(param) {
    view = param;
    setViewedPage(param)
  }

  function handleMenuLogout() {

    let token = localStorage.getItem('token');   
    fetch(`https://${global.api_url}/invalidateToken.php?ts=${getTimestamp()}`, {
      method: "POST",
      headers: { token }
    }).then(res => res.json())
      .then(json => {

        localStorage.clear();

        if (localStorage.getItem('agentEmail') == null) {
          window.location.href = "/logout/logout";
        } else {
          window.location.href = "/agent";
        }

        setLoggedInAs("");
        localStorage.setItem("logged_in_as", "");

    });
  }

  const Footer = () => {
    let date  = new Date
    date = date.getFullYear()
    const styles = {
        footer: {
            alignSelf: "center",
            justifyContent: "center",
            paddingBottom: 5,
            fontSize: 10,
            color: "#000000",
        },
        hyperLink: {
            color: "#000000"
        }
    };
    return(
        <div>
            <div style={styles.footer}>
                <p>
                    © 2019-{date} untied | All rights reserved |{" "} <br/>
                    <a
                        style={styles.hyperLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.untied.io/untied-privacy-policy/"
                    >
                        Privacy Policy
                    </a>{" "}
                    |{" "}
                    <a
                        style={styles.hyperLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.untied.io/untied-app-terms-conditions/"
                    >
                        Terms of Service
                    </a>
                </p>
            </div>
        </div>
    );
};



  return (
    <div>
      <UntiedAppBar
        className={clsx(classes.appBar, {
          [classes.appBarShift]: drwr
        })}
        open={!closed}
        loggedInAs={loggedInAs}
      />
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: !closed,
          [classes.drawerClose]: closed
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: !closed,
            [classes.drawerClose]: closed
          })
        }}
      >

        <div className="menu-icon-container">
          {!closed && (<div className="untied-logo" />)}
          {closed && ((advisor ? <div className="untied-tax-berry-green" /> : <div className="untied-tax-berry" />))}
        </div>

        <div style = {!closed ? {marginTop: "30px",display: "flex", flexDirection: "row", justifyContent: "space-between", height: "25px"} : { height: "55px"}}>
        {!closed &&<>
        <div className={!closed ? "mobile-overlay-hidden" : "mobile-overlay"} />
          <div className="logged-in-container">
            <div style = {{fontSize:"8px", fontStyle: "italic"}}>{advisor? "Managing:" :"Logged in as"}</div>
            {/* {console.log("user email:",userEmail)} */}
            <div  style={{overflow: "hidden", textOverflow: "ellipsis", width: "160px", fontWeight:"600", fontSize: "12px",}}>{userEmail && userEmail.toLowerCase()}</div>
          </div>
          </>
            }
        

        <div className="menu-arrow-container" style ={closed ? {marginTop: "30px"} : {}}>
        
          <IconButton onClick={closed ? handleDrawerOpen : handleDrawerClose}>
            <ChevronLeftIcon style={{ transform: rotate, transition: "all .3s ease" }}/>
          </IconButton>
        </div>
        </div>

        {plan === 'N' &&
        <MenuItem
            component={Link}
            to={{pathname: "/plan", state: "Manage your plan"}}

            className={viewedPage === "profileUpgrade" ? "menu-item-current" : "menu-item-default-upgrade"}
            onClick={() => {
              Mixpanel.track("clicked_upgrade_button");
              setActiveView("profileMain");
            }}
        >
        {closed && 
          <ListItemIcon>
            <ShoppingCartIcon style={{height: 20, width: 20,}} />
          </ListItemIcon>
          }
          <span className="item-label" style = {{ marginLeft: "20px"}}>Upgrade to pro</span>
        </MenuItem>
        }


        <Divider style = {{backgroundColor: "#FD349C", opacity: "0.7", height: "2px", marginTop: "5px"}}/>

        <MenuItem component={Link} to="/home" className={viewedPage === "home" ? "menu-item-current" : "menu-item-default"} onClick={() => setActiveView("home")}>
          <ListItemIcon >
           <svg 
           class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root css-uqopch" 
           focusable="false" 
           aria-hidden="true" 
           viewBox="0 0 24 24" 
           data-testid="HomeIcon">
           <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"></path></svg>
          </ListItemIcon>
          <span className="item-label">Home</span>
        </MenuItem>

        <MenuItem component={Link} to="/transactions" className={viewedPage === "transactions" ? "menu-item-current" : "menu-item-default"} onClick={() => setActiveView("transactions")}>
          <ListItemIcon>
            <SwapHoriz style={{height: 24, width: 24}}/>
          </ListItemIcon>
            <span className="item-label">Transactions</span>
        </MenuItem>

        <MenuItem component={Link} to="/journeys" className={viewedPage === "journeys" ? "menu-item-current" : "menu-item-default"} onClick={() => setActiveView("journeys")}>
          <ListItemIcon>
            <Motorcycle style={{height: 20, width: 20}}/>
          </ListItemIcon>
          <span className="item-label">Journeys</span>
        </MenuItem>

        <Divider />
        {/*
          <MenuItem component={Link} to="/ManualTransactionsImporter">
            <ListItemIcon>
              {" "}
              <ImportantDevicesIcon style={{ color: "black" }} />{" "}
            </ListItemIcon>
            Import CSV
          </MenuItem>
        */}
        <MenuItem component={Link} to="/accounts" className={viewedPage === "accounts" ? "menu-item-current" : "menu-item-default"} onClick={() => setActiveView("accounts")}>
          <ListItemIcon>
            <AccountBalance style={{height: 20, width: 20}}/>
          </ListItemIcon>
          <span className="item-label">Accounts</span>
        </MenuItem>

        <MenuItem component={Link} to="/rules" className={viewedPage === "rules" ? "menu-item-current" : "menu-item-default"} onClick={() => setActiveView("rules")}>
          <ListItemIcon>
            <FilterList style={{height: 20, width: 20}}/>
          </ListItemIcon>
          <span className="item-label">Rules</span>
        </MenuItem>

        <MenuItem component={Link} to="/payment" className={viewedPage === "payment" ? "menu-item-current" : "menu-item-default"} onClick={() => setActiveView("payment")}>
          <ListItemIcon >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                height="20"
                width="20"
                viewBox="0 0 24 24"
            >
              <path d="M6 21v-2c4-2 3.5-6 3.5-6H7v-2h2.5c-1-4.5.5-8 4.5-8c2 0 3 .5 3 .5v2c-6-2-6 2.5-5.5 5.5H16v2h-4.5s.5 4-2 6H18v2H6z"/>
            </svg>
          </ListItemIcon>
          <span className="item-label">Payments & invoices</span>
        </MenuItem>

        {/* <MenuItem component={Link} to="/insights">
          <ListItemIcon>
            <WbIncandescentIcon style={{ color: "#00338d" }} />
          </ListItemIcon>
            Insights (beta)
          </MenuItem> */}
        <Divider />

        <MenuItem component={Link} to="/taxBreakdown" className={viewedPage === "taxBreakdown" ? "menu-item-current" : "menu-item-default"} onClick={() => setActiveView("taxBreakdown")}>
          <ListItemIcon>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                height="20"
                width="20"
                viewBox="0 0 24 24"
            >
              <path d="M0 0h24v24H0z" fill="none" />
              <path d="M4 14h4v-4H4v4zm0 5h4v-4H4v4zM4 9h4V5H4v4zm5 5h12v-4H9v4zm0 5h12v-4H9v4zM9 5v4h12V5H9z" />
            </svg>
          </ListItemIcon>
          <span className="item-label">Tax breakdown</span>
        </MenuItem>


        <MenuItem component={Link} to={{pathname: "/taxForms/menu"}} className={viewedPage === "taxForms" ? "menu-item-current" : "menu-item-default"} onClick={() => setActiveView("taxForms")}>
          <ListItemIcon>
            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 1160 1200">
              <g transform="translate(0.000000,1200.000000) scale(0.12,-0.100000)" >
                <path d="M4904 9915 c-125 -39 -206 -120 -262 -259 -15 -37 -17 -142 -22 -1011 l-5 -970 -23 -57 c-33 -82 -128 -177 -207 -209 l-60 -24 -970 -5 c-1051 -6 -981 -2 -1092 -59 -53 -27 -130 -112 -162 -181 l-26 -55 -3 -2345 c-2 -2160 -1 -2348 14 -2395 42 -125 134 -217 259 -259 47 -15 253 -16 2690 -14 l2640 3 55 26 c125 59 210 173 231 312 6 37 8 515 7 1195 l-3 1132 -750 -691 c-412 -381 -777 -714 -810 -741 -33 -26 -94 -66 -135 -87 -83 -43 -1256 -525 -1335 -548 -75 -23 -195 -14 -267 19 -117 54 -207 172 -227 298 -19 120 -12 139 314 789 163 327 314 623 336 660 70 114 109 158 289 324 96 88 718 662 1383 1275 l1207 1114 0 1192 c0 699 -4 1215 -10 1249 -20 122 -101 241 -199 292 -90 46 -43 45 -1471 44 -1068 -1 -1353 -4 -1386 -14z m1431 -3465 c-22 -21 -164 -154 -315 -294 l-275 -255 -1430 2 -1430 2 -51 23 c-60 27 -113 79 -146 142 -19 37 -23 60 -23 130 0 75 3 91 29 138 32 57 98 113 163 137 32 11 309 14 1778 14 l1740 1 -40 -40z m-1311 -1212 c-177 -160 -319 -314 -384 -416 l-65 -101 -845 2 -845 2 -51 23 c-60 27 -113 79 -146 142 -19 37 -23 60 -23 130 0 75 3 91 29 137 33 60 89 108 155 134 43 17 108 18 1150 19 l1103 0 -78 -72z m-902 -1403 l-147 -296 -545 3 -545 3 -51 23 c-60 27 -113 79 -146 142 -19 37 -23 60 -23 130 0 75 3 91 29 137 33 60 89 108 155 134 43 17 94 18 733 19 l688 0 -148 -295z" />
                <path d="M3050 8945 l-975 -975 816 0 c698 0 823 2 866 15 115 34 239 165 263 278 8 37 10 288 8 855 l-3 802 -975 -975z" />
                <path d="M9534 7764 c-23 -8 -63 -34 -91 -57 -27 -24 -571 -524 -1209 -1113 -637 -589 -1487 -1375 -1889 -1745 l-730 -674 -188 -372 c-153 -304 -183 -371 -165 -364 168 65 721 297 749 314 20 12 381 339 801 727 419 388 1265 1168 1878 1733 613 566 1132 1048 1153 1071 22 22 50 65 64 95 22 46 25 63 21 125 -8 117 -62 200 -163 247 -69 33 -160 38 -231 13z" />
              </g>
            </svg>
          </ListItemIcon>
          <span className="item-label">Tax forms</span>
        </MenuItem>

        <MenuItem component={Link} to="/taxReturns" className={viewedPage === "taxReturns" ? "menu-item-current" : "menu-item-default"} onClick={() => setActiveView("taxReturns")}>
          <ListItemIcon>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
            >
              <path d="M19 3H4.99c-1.11 0-1.98.9-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10zm-3-5h-2V7h-4v3H8l4 4 4-4z" />
              <path fill="none" d="M0 0h24v24H0V0z" />
            </svg>
          </ListItemIcon>
          <span className="item-label">Tax filings</span>
          </MenuItem>

        {isMTDUser() && (
          <MenuItem component={Link} to="/MTD" className={viewedPage === "MTD" ? "menu-item-current" : "menu-item-default"} onClick={() => setActiveView("MTD")}>
            <ListItemIcon>

            <svg xmlns="http://www.w3.org/2000/svg"   
              width="20"
              height="20"  
              viewBox="0 0 24 24"><path d="M20 18c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2H0c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2h-4zM4 5h16v11H4V5zm8 14c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"></path></svg>
           
              {/* <svg 
              xmlns="http://www.w3.org/2000/svg"   
              width="20"
              height="20"  
              viewBox="0 0 24 24" ><path d="M21 18v1c0 1.1-.9 2-2 2H5c-1.11 0-2-.9-2-2V5c0-1.1.89-2 2-2h14c1.1 0 2 .9 2 2v1h-9c-1.11 0-2 .9-2 2v8c0 1.1.89 2 2 2h9zm-9-2h10V8H12v8zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"></path></svg> */}
            </ListItemIcon>
            <span className="item-label">Digital Tax</span>
          </MenuItem>
        )}

        <MenuItem component={Link} to="/hmrcpay" onClick={() => setActiveView("hmrcpay")} className={viewedPage === "hmrcpay" ? "menu-item-current" : "menu-item-default"}>
          <ListItemIcon>
            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" ><path d="M0 0h24v24H0z" fill="none" /><path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z" /></svg>
          </ListItemIcon>
          
          <span className="item-label">Pay HMRC</span>
        </MenuItem>


        <Divider  />


{/* 
        <MenuItem component={Link} to="/profile" className={view === "profile" ? "menu-item-current" : "menu-item-default"} onClick={() => setActiveView("profile")}>
          <ListItemIcon>
            <SettingsIcon style={{height: 20, width: 20}}/>
          </ListItemIcon>
          <span className="item-label">Settings</span>
        </MenuItem> */}




        <MenuItem component={Link} to="/cov19" className={viewedPage === "cov19" ? "menu-item-current" : "menu-item-default"} onClick={() => setActiveView("cov19")}>
          <ListItemIcon>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
            >
              <path d="M20,6h-4V4c0-1.1-0.9-2-2-2h-4C8.9,2,8,2.9,8,4v2H4C2.9,6,2,6.9,2,8v12c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V8 C22,6.9,21.1,6,20,6z M10,4h4v2h-4V4z M15,15h-2v2c0,0.55-0.45,1-1,1s-1-0.45-1-1v-2H9c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1h2v-2 c0-0.55,0.45-1,1-1s1,0.45,1,1v2h2c0.55,0,1,0.45,1,1C16,14.55,15.55,15,15,15z"/>
            </svg>
          </ListItemIcon>
          <span className="item-label">COVID-19 support</span>
        </MenuItem>

        <MenuItem component={Link} to="/profileMain" className={viewedPage === "profileMain" ? "menu-item-current" : "menu-item-default"} onClick={() => setActiveView("profileMain")}>
          <ListItemIcon>
              <svg 
              xmlns="http://www.w3.org/2000/svg" 
              height="24" width="24" 
              version="1.1" 
              x="0px" 
              y="0px" 
              viewBox="0 0 60 60" 
              >
              <path d="M53.1800537,25.7199707l-6.1900024-1.0700073c-0.3099976-0.9899902-0.7000122-1.9599609-1.1799927-2.8899536  l3.6099854-5.1100464c0.2799683-0.3999634,0.2299805-0.9400024-0.1099854-1.289978l-4.6600342-4.6600342  c-0.3399658-0.3499756-0.8800049-0.3899536-1.2799683-0.1099854l-5.0700073,3.5900269  c-0.9400024-0.5-1.9200439-0.9100342-2.9500122-1.2300415l-1.0599976-6.1199951C34.210022,6.3499756,33.8000488,6,33.3100586,6  H26.710022c-0.4799805,0-0.8999634,0.3499756-0.9799805,0.8299561l-1.0599976,6.1100464  c-1.0100098,0.3200073-2,0.7299805-2.9500122,1.2399902l-5.0700073-3.5900269  C16.25,10.3099976,15.710022,10.3499756,15.3700562,10.6999512l-4.6500244,4.6600342  c-0.3499756,0.3499756-0.3900146,0.8900146-0.1099854,1.289978l3.5999756,5.1100464  c-0.4799805,0.9299927-0.8699951,1.8999634-1.1799927,2.8899536l-6.2000122,1.0700073  C6.3500366,25.7999878,6,26.2199707,6,26.7099609v6.5900269c0,0.4899902,0.3600464,0.9099731,0.8400269,0.9899902l6.25,1.0700073  c0.3099976,0.9699707,0.710022,1.9099731,1.1699829,2.8099976l-3.6499634,5.2000122  c-0.2800293,0.3900146-0.2399902,0.9299927,0.1099854,1.2799683l4.6500244,4.6500244  c0.3399658,0.3399658,0.8799438,0.3900146,1.2799683,0.1099854l5.2200317-3.6900024  c0.8899536,0.460022,1.8099976,0.8400269,2.7699585,1.1400146l1.0900269,6.3099976  C25.8100586,53.6499634,26.2300415,54,26.710022,54h6.6000366c0.4899902,0,0.8999634-0.3500366,0.9799805-0.8300171  l1.0899658-6.3099976c0.9500122-0.2999878,1.8699951-0.6799927,2.7700195-1.1400146l5.2200317,3.6900024  c0.3999634,0.2800293,0.9400024,0.2299805,1.2799683-0.1099854l4.6600342-4.6500244  c0.3399658-0.3499756,0.3899536-0.8899536,0.1099854-1.2799683l-3.6600342-5.2000122  c0.4700317-0.9000244,0.8600464-1.8400269,1.1700439-2.8099976l6.2399902-1.0700073  C53.6500244,34.2099609,54,33.789978,54,33.2999878v-6.5900269C54,26.2199707,53.6500244,25.7999878,53.1800537,25.7199707z   M30,42.6699829c-6.9799805,0-12.6699829-5.6799927-12.6699829-12.6699829S23.0200195,17.3200073,30,17.3200073  c6.9900513,0,12.6800537,5.6900024,12.6800537,12.6799927S36.9900513,42.6699829,30,42.6699829z"/><path d="M30.0004883,31.539917c2.493042,0,4.5197144-2.0267334,4.5197144-4.5197144s-2.0266724-4.5101929-4.5197144-4.5101929  c-2.4834595,0-4.5101929,2.0172119-4.5101929,4.5101929S27.5170288,31.539917,30.0004883,31.539917z"/><path d="M30.0100098,33.0299683c-3.1799927,0-6.0999756,1.5400391-7.8899536,4.1500244  C24.0700073,39.3200073,26.8800049,40.6699829,30,40.6699829c3.1200562,0,5.9400024-1.3499756,7.8900146-3.4899902  C36.1000366,34.5700073,33.1800537,33.0299683,30.0100098,33.0299683z"/></svg>
          </ListItemIcon>
          <span className="item-label">Profile & settings</span>
        </MenuItem>

        {user_atom.submissions_enabled==='Y' && (
        <MenuItem component={Link} to="/tutorials/menu" className={viewedPage === "tutorials" ? "menu-item-current" : "menu-item-default"} onClick={() => setActiveView("tutorials")}>
          <ListItemIcon>
          <svg xmlns="http://www.w3.org/2000/svg" 
          height="24px" viewBox="0 0 24 24" 
          width="24px" fill="#FFFFFF"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 15c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1zm1-8h-2V7h2v2z"/></svg>
          </ListItemIcon>
          <span className="item-label">Tutorials</span>
        </MenuItem>
        )}


        <MenuItem
          onClick={() => { window.open("https://help.untied.io/", "_blank") }}
          to="https://help.untied.io/"
          target="_blank"
          className="menu-item-default"
        >
          <ListItemIcon>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
            >
              <path d="M0 0h24v24H0z" fill="none" />
              <path d="M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z" />
            </svg>
          </ListItemIcon>
          Get help
        </MenuItem>




        <div className="logout-item">
        
          <Divider/>
          <MenuItem
              onClick={() => handleMenuLogout()}
              to="https://help.untied.io/"
              target="_blank"
              className="menu-item-default"
          >
            <ListItemIcon>
              <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="26"
                  width="26"
                  viewBox="0 0 512 520"
              >
                <g>
                  <path d="M237,179.3c9.4,0,17-7.6,17-17v-35.6c0-7.2,5.9-12.7,13.1-12.7h134.2c7.2,0,12.7,5.5,12.7,12.7v258.6   c0,7.2-5.5,12.7-12.7,12.7H267.1c-7.2,0-13.1-5.5-13.1-12.7v-34.9c0-9.4-7.6-17-17-17s-17,7.6-17,17v34.9   c0,25.9,21.2,46.7,47.1,46.7h134.2c25.9,0,46.7-20.8,46.7-46.7V126.7c0-25.9-20.8-46.7-46.7-46.7H267.1   c-25.9,0-47.1,20.8-47.1,46.7v35.6C220,171.7,227.6,179.3,237,179.3z"/>
                  <path d="M70.2,269.3l64.4,64.4c3.3,3.3,7.7,5,12,5s8.7-1.7,12-5c6.6-6.6,6.6-17.4,0-24L121.9,273h219.8   c9.4,0,17-7.6,17-17s-7.6-17-17-17H118.2l41.2-47.5c6.2-7.1,5.4-17.8-1.7-24c-7.1-6.2-17.8-5.4-24,1.7l-64.4,74.2   c-3.4,3.1-5.6,7.6-5.6,12.6C63.7,261.4,66.2,266.2,70.2,269.3z"/>
                </g>
              </svg>

            </ListItemIcon>
            Log out
          </MenuItem>
          <Divider />
        </div>

        
        <div className="footer-item">
          <div className={!closed ? "mobile-overlay-hidden" : "mobile-overlay"} />
         <Footer/>
        </div>


       

      </Drawer>

    </div>
  );
}
const drawerWidth = 220;
// eslint-disable-next-line
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    backgroundColor: "#00338d"
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: 2000
    })
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  menuButton: {
    marginRight: theme.spacing(2)
  },
  hide: {
    display: "none"
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap"
  },
  drawerOpen: {
    width: drawerWidth,
    overflow: "hidden",
    transition: theme.transitions.create("width", {
      easing: 'cubic-bezier(0.42, 0, 0.58, 1.0)',
      duration: 400
    })
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: 'cubic-bezier(0.42, 0, 0.58, 1.0)',
      duration: 400
    }),
    overflow: "hidden",
    width: theme.spacing(7) + 1
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    height: 50,
    ...theme.mixins.toolbar
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: "0 8px",
    ...theme.mixins.toolbar,
    justifyContent: "flex-end"
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    marginLeft: -drawerWidth
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    }),
    marginLeft: 0
  }
}));
